module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Neuhausen_am_Rheinfall-c36b1b1e0482e60655ac817c58c73507.png";